import { render } from "./BannerActie.vue?vue&type=template&id=80e67150"
import script from "./BannerActie.vue?vue&type=script&lang=js"
export * from "./BannerActie.vue?vue&type=script&lang=js"

import "./BannerActie.vue?vue&type=style&index=0&id=80e67150&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__